import styled from 'styled-components';

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-top: ${(props) => props.$isStandalone ? 'none' : '1px solid #e7e8ec'};
  border: ${(props) => props.$isStandalone ? '1px solid #e7e8ec' : 'none'};
  border-radius: ${(props) => props.$isStandalone ? '8px' : '0'};
`;

export const ItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.colors.backgroundHover || '#f5f5f5'};
  }
`;

export const ItemHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  flex: 1;
`;

export const ItemHeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${(props) => props.theme.spacing.xs};
`;

export const AvatarInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
  width: 160px;
`;


export const ItemMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.theme.spacing.xs};
  align-items: center;
`;

export const ExpandIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.md};
  padding: 8px 16px 12px 16px;
  background: #fafafa;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const RationaleBox = styled.div`
  padding:12px;
  background: #ffffff;
  border: 1px solid #e7e8ec;
  border-radius: 8px;
`;

export const ComparisonSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const ComparisonRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;
`;

export const CurrentValue = styled.div`
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e7e8ec;
  border-radius: 8px;
  font-size: 14px;
  color: #000000;
`;

export const SuggestedValue = styled.div`
  padding: 12px;
  background: #e8f5e9;
  border: 1px solid #4caf50;
  border-radius: 8px;
  font-size: 14px;
  color: #000000;
`;

